/**
 * @ngdoc service
 * @name checkins.factory:addContactToPicklists
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('addContactToPicklists', [
        'addContactsToPicklists',
        'Contacts',
        addContactToPicklists
    ]);

function addContactToPicklists(addContactsToPicklists, Contacts) {
    return {
        key: 'add-contact-to-picklists',
        title: 'Add To Picklist',
        level: 'highlight',
        icon: 'users',
        order: 80,
        action(contact) {
            const store = Contacts.reset({persist: false});
            store.commit('selectRow', contact.id);
            return addContactsToPicklists.action({}, store);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/add-contact-to-picklists.js